import mixpanel, { Config, Dict } from "mixpanel-browser";

const MIXPANEL_TOKEN = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN;

interface ExtendedConfig extends Config {
  autocapture?:
    | boolean
    | {
        pageview?: string | boolean;
        click?: boolean;
        input?: boolean;
        scroll?: boolean;
        submit?: boolean;
        capture_text_content?: boolean;
      };
}

const config: Partial<ExtendedConfig> = {
  debug: false,
  track_pageview: true,
  autocapture: {
    pageview: "full-url",
    click: true,
    input: false,
    scroll: false,
    submit: false,
    capture_text_content: true,
  },
};

if (MIXPANEL_TOKEN) {
  mixpanel.init(MIXPANEL_TOKEN, config);
}

const isTrackingEnabled = () => {
  return !!MIXPANEL_TOKEN;
};

const Mixpanel = {
  track: (event: string, props?: Dict) => {
    if (isTrackingEnabled()) {
      mixpanel.track(event, props);
    }
  },

  identify: (userId?: string) => {
    if (isTrackingEnabled()) {
      mixpanel.identify(userId);
    }
  },
  people: {
    set: (distinctId: string, props: Dict) => {
      if (isTrackingEnabled()) {
        Mixpanel.identify(distinctId);
        mixpanel.people.set(props);
      }
    },
  },
  reset: () => {
    if (isTrackingEnabled()) {
      mixpanel.reset();
    }
  },
};

export default Mixpanel;
